import { createBrowserHistory } from "history";
export default createBrowserHistory();

// we use this to keep track of user routing.